//Zoopla Information Graphics
//Zoopla 2023 - Data Visualizations
//Deisgned and developed by Paulius Zutautas
//Value of Housing data-vis tool


//import noUiSlider from 'nouislider';
//import wNumb from 'wnumb';
//import 'nouislider/distribute/nouislider.css';
import "./scss/app.scss";
//import "./components/leaflet-responsive-attribution.js";
//import "./components/leaflet-responsive-attribution.css";
import "./images/pin.png";
//import "./scss/nouislider.css";

import { labeledXAxis } from "./xAxisLabels.js";
import { labeledYAxis } from "./yAxisLabels.js";
//import { mouseover, mouseout, mousemove } from "./mouseInteractions.js";
//import { mousemoveHighlight } from "./mousemoveHighlight.js";


(function(){
  'use strict'
  
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
// Type it here
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  $("#mainDataDiv").hide();
  $("#inputResultsOne, #inputResultsTwo, #inputResultsThree").hide();
  //const mainData = 'https://storage.googleapis.com/iframe_content/zoopla%20visual%20stories/2022/house%20price%20value%20change%202020-22/outcode%20search%20tool/value_housing_2020_2022_matching_postcode_district_data.csv';
  const mainData = 'https://storage.googleapis.com/iframe_content/zoopla%20visual%20stories/2023/value-of-housing-2023/value_housing_2023_data.csv';

  let valueTop;
  let valueBottom;
  //const nodata = `no data`;

  const nodata = `<svg width="102" height="24" viewBox="0 0 102 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.88045 13.276V7.552H8.50045V16H6.83245L2.74045 10.144V16H1.12045V7.552H2.89645L6.88045 13.276ZM13.3846 16.192C12.7526 16.192 12.1806 16.056 11.6686 15.784C11.1566 15.504 10.7566 15.12 10.4686 14.632C10.1806 14.136 10.0366 13.576 10.0366 12.952C10.0366 12.328 10.1806 11.768 10.4686 11.272C10.7566 10.776 11.1526 10.388 11.6566 10.108C12.1686 9.828 12.7446 9.688 13.3846 9.688C14.0246 9.688 14.5966 9.828 15.1006 10.108C15.6046 10.388 15.9966 10.776 16.2766 11.272C16.5646 11.76 16.7086 12.316 16.7086 12.94C16.7086 13.564 16.5646 14.124 16.2766 14.62C15.9886 15.116 15.5926 15.504 15.0886 15.784C14.5846 16.056 14.0166 16.192 13.3846 16.192ZM13.3846 14.716C13.8966 14.716 14.3086 14.552 14.6206 14.224C14.9326 13.896 15.0886 13.468 15.0886 12.94C15.0886 12.412 14.9326 11.984 14.6206 11.656C14.3086 11.32 13.8966 11.152 13.3846 11.152C12.8726 11.152 12.4566 11.32 12.1366 11.656C11.8166 11.984 11.6566 12.412 11.6566 12.94C11.6566 13.468 11.8166 13.896 12.1366 14.224C12.4566 14.552 12.8726 14.716 13.3846 14.716ZM20.5455 16.06C19.7615 16.06 19.1975 15.868 18.8535 15.484C18.5175 15.092 18.3495 14.528 18.3495 13.792V11.212H17.4135V9.88H18.3495V8.272H19.9335V9.88H21.7935V11.212H19.9335V13.708C19.9335 14.388 20.2455 14.728 20.8695 14.728C21.1895 14.728 21.4935 14.644 21.7815 14.476V15.748C21.6295 15.844 21.4415 15.92 21.2175 15.976C20.9935 16.032 20.7695 16.06 20.5455 16.06ZM31.5645 14.26C31.3885 14.892 31.0405 15.372 30.5205 15.7C30.0005 16.028 29.4085 16.192 28.7445 16.192C28.1205 16.192 27.5645 16.052 27.0765 15.772C26.5885 15.492 26.2085 15.108 25.9365 14.62C25.6725 14.124 25.5405 13.568 25.5405 12.952C25.5405 12.336 25.6685 11.78 25.9245 11.284C26.1885 10.788 26.5605 10.4 27.0405 10.12C27.5285 9.832 28.0885 9.688 28.7205 9.688C29.3285 9.688 29.8525 9.824 30.2925 10.096C30.7405 10.36 31.0805 10.74 31.3125 11.236C31.5525 11.732 31.6725 12.312 31.6725 12.976C31.6725 13.112 31.6685 13.228 31.6605 13.324H27.0525C27.1085 13.852 27.2885 14.248 27.5925 14.512C27.9045 14.776 28.2965 14.908 28.7685 14.908C29.0565 14.908 29.3125 14.852 29.5365 14.74C29.7605 14.62 29.9325 14.46 30.0525 14.26H31.5645ZM30.1485 12.28C30.1005 11.864 29.9445 11.544 29.6805 11.32C29.4245 11.096 29.1045 10.984 28.7205 10.984C28.3125 10.984 27.9645 11.096 27.6765 11.32C27.3965 11.536 27.2085 11.856 27.1125 12.28H30.1485ZM36.5664 9.688C37.3104 9.688 37.8864 9.924 38.2944 10.396C38.7024 10.868 38.9064 11.512 38.9064 12.328V16H37.3224V12.436C37.3224 11.996 37.2104 11.66 36.9864 11.428C36.7624 11.196 36.4344 11.08 36.0024 11.08C35.5784 11.08 35.2344 11.224 34.9704 11.512C34.7064 11.792 34.5744 12.168 34.5744 12.64V16H33.0024V9.88H34.5744V11.092C34.7584 10.66 35.0184 10.32 35.3544 10.072C35.6904 9.816 36.0944 9.688 36.5664 9.688ZM43.455 16.192C42.823 16.192 42.251 16.056 41.739 15.784C41.227 15.504 40.827 15.12 40.539 14.632C40.251 14.136 40.107 13.576 40.107 12.952C40.107 12.328 40.251 11.768 40.539 11.272C40.827 10.776 41.223 10.388 41.727 10.108C42.239 9.828 42.815 9.688 43.455 9.688C44.095 9.688 44.667 9.828 45.171 10.108C45.675 10.388 46.067 10.776 46.347 11.272C46.635 11.76 46.779 12.316 46.779 12.94C46.779 13.564 46.635 14.124 46.347 14.62C46.059 15.116 45.663 15.504 45.159 15.784C44.655 16.056 44.087 16.192 43.455 16.192ZM43.455 14.716C43.967 14.716 44.379 14.552 44.691 14.224C45.003 13.896 45.159 13.468 45.159 12.94C45.159 12.412 45.003 11.984 44.691 11.656C44.379 11.32 43.967 11.152 43.455 11.152C42.943 11.152 42.527 11.32 42.207 11.656C41.887 11.984 41.727 12.412 41.727 12.94C41.727 13.468 41.887 13.896 42.207 14.224C42.527 14.552 42.943 14.716 43.455 14.716ZM52.3079 9.88H53.8919V16H52.3079V14.812C52.1239 15.236 51.8639 15.572 51.5279 15.82C51.1919 16.068 50.7879 16.192 50.3159 16.192C49.5719 16.192 48.9959 15.956 48.5879 15.484C48.1879 15.012 47.9879 14.368 47.9879 13.552V9.88H49.5599V13.444C49.5599 13.876 49.6719 14.212 49.8959 14.452C50.1199 14.684 50.4479 14.8 50.8799 14.8C51.3039 14.8 51.6479 14.66 51.9119 14.38C52.1759 14.092 52.3079 13.712 52.3079 13.24V9.88ZM60.2644 9.88H61.8244V15.016C61.8244 16.112 61.5124 16.96 60.8884 17.56C60.2644 18.168 59.4204 18.472 58.3564 18.472C57.8764 18.472 57.4244 18.424 57.0004 18.328C56.5844 18.232 56.2204 18.092 55.9084 17.908V16.372C56.6124 16.828 57.4044 17.056 58.2844 17.056C59.6044 17.056 60.2644 16.356 60.2644 14.956V14.692C60.0244 15.068 59.7124 15.364 59.3284 15.58C58.9524 15.788 58.5284 15.892 58.0564 15.892C57.4964 15.892 57.0004 15.756 56.5684 15.484C56.1364 15.212 55.8004 14.844 55.5604 14.38C55.3284 13.908 55.2124 13.38 55.2124 12.796C55.2124 12.204 55.3324 11.672 55.5724 11.2C55.8124 10.728 56.1484 10.36 56.5804 10.096C57.0124 9.824 57.5004 9.688 58.0444 9.688C58.5244 9.688 58.9524 9.796 59.3284 10.012C59.7124 10.22 60.0244 10.516 60.2644 10.9V9.88ZM58.5604 14.524C59.0724 14.524 59.4844 14.368 59.7964 14.056C60.1084 13.736 60.2644 13.316 60.2644 12.796C60.2644 12.284 60.1044 11.868 59.7844 11.548C59.4724 11.228 59.0644 11.068 58.5604 11.068C58.0484 11.068 57.6324 11.228 57.3124 11.548C57.0004 11.868 56.8444 12.284 56.8444 12.796C56.8444 13.308 57.0044 13.724 57.3244 14.044C57.6444 14.364 58.0564 14.524 58.5604 14.524ZM67.0937 9.688C67.8377 9.688 68.4137 9.924 68.8217 10.396C69.2297 10.868 69.4337 11.512 69.4337 12.328V16H67.8497V12.436C67.8497 11.996 67.7377 11.66 67.5137 11.428C67.2897 11.196 66.9617 11.08 66.5297 11.08C66.1057 11.08 65.7617 11.224 65.4977 11.512C65.2337 11.792 65.1017 12.168 65.1017 12.64V16H63.5297V7.3H65.1017V11.092C65.2857 10.66 65.5457 10.32 65.8817 10.072C66.2177 9.816 66.6217 9.688 67.0937 9.688ZM78.5585 7.3H80.1425V16H78.5585V14.98C78.3185 15.364 78.0105 15.664 77.6345 15.88C77.2585 16.088 76.8465 16.192 76.3985 16.192C75.8385 16.192 75.3345 16.056 74.8865 15.784C74.4385 15.504 74.0865 15.12 73.8305 14.632C73.5825 14.136 73.4585 13.576 73.4585 12.952C73.4585 12.328 73.5825 11.768 73.8305 11.272C74.0865 10.776 74.4385 10.388 74.8865 10.108C75.3345 9.828 75.8385 9.688 76.3985 9.688C76.8545 9.688 77.2665 9.796 77.6345 10.012C78.0105 10.22 78.3185 10.516 78.5585 10.9V7.3ZM76.8065 14.728C77.3265 14.728 77.7465 14.568 78.0665 14.248C78.3945 13.92 78.5585 13.488 78.5585 12.952C78.5585 12.408 78.3945 11.972 78.0665 11.644C77.7385 11.308 77.3185 11.14 76.8065 11.14C76.3025 11.14 75.8865 11.308 75.5585 11.644C75.2385 11.972 75.0785 12.408 75.0785 12.952C75.0785 13.48 75.2425 13.908 75.5705 14.236C75.8985 14.564 76.3105 14.728 76.8065 14.728ZM86.5624 9.88H88.1464V16H86.5624V14.98C86.3224 15.364 86.0144 15.664 85.6384 15.88C85.2624 16.088 84.8504 16.192 84.4024 16.192C83.8424 16.192 83.3384 16.056 82.8904 15.784C82.4424 15.504 82.0904 15.12 81.8344 14.632C81.5864 14.136 81.4624 13.576 81.4624 12.952C81.4624 12.328 81.5864 11.768 81.8344 11.272C82.0904 10.776 82.4424 10.388 82.8904 10.108C83.3384 9.828 83.8424 9.688 84.4024 9.688C84.8584 9.688 85.2704 9.796 85.6384 10.012C86.0144 10.22 86.3224 10.516 86.5624 10.9V9.88ZM84.8104 14.728C85.3304 14.728 85.7504 14.568 86.0704 14.248C86.3984 13.92 86.5624 13.488 86.5624 12.952C86.5624 12.408 86.3984 11.972 86.0704 11.644C85.7424 11.308 85.3224 11.14 84.8104 11.14C84.3064 11.14 83.8904 11.308 83.5624 11.644C83.2424 11.972 83.0824 12.408 83.0824 12.952C83.0824 13.48 83.2464 13.908 83.5744 14.236C83.9024 14.564 84.3144 14.728 84.8104 14.728ZM92.3463 16.06C91.5623 16.06 90.9983 15.868 90.6543 15.484C90.3183 15.092 90.1503 14.528 90.1503 13.792V11.212H89.2143V9.88H90.1503V8.272H91.7343V9.88H93.5943V11.212H91.7343V13.708C91.7343 14.388 92.0463 14.728 92.6703 14.728C92.9903 14.728 93.2943 14.644 93.5823 14.476V15.748C93.4303 15.844 93.2423 15.92 93.0183 15.976C92.7943 16.032 92.5703 16.06 92.3463 16.06ZM99.5116 9.88H101.096V16H99.5116V14.98C99.2716 15.364 98.9636 15.664 98.5876 15.88C98.2116 16.088 97.7996 16.192 97.3516 16.192C96.7916 16.192 96.2876 16.056 95.8396 15.784C95.3916 15.504 95.0396 15.12 94.7836 14.632C94.5356 14.136 94.4116 13.576 94.4116 12.952C94.4116 12.328 94.5356 11.768 94.7836 11.272C95.0396 10.776 95.3916 10.388 95.8396 10.108C96.2876 9.828 96.7916 9.688 97.3516 9.688C97.8076 9.688 98.2196 9.796 98.5876 10.012C98.9636 10.22 99.2716 10.516 99.5116 10.9V9.88ZM97.7596 14.728C98.2796 14.728 98.6996 14.568 99.0196 14.248C99.3476 13.92 99.5116 13.488 99.5116 12.952C99.5116 12.408 99.3476 11.972 99.0196 11.644C98.6916 11.308 98.2716 11.14 97.7596 11.14C97.2556 11.14 96.8396 11.308 96.5116 11.644C96.1916 11.972 96.0316 12.408 96.0316 12.952C96.0316 13.48 96.1956 13.908 96.5236 14.236C96.8516 14.564 97.2636 14.728 97.7596 14.728Z" fill="#322744"/>
</svg>`
  //Postcode Area Input

  // $("#myInputOne").on("keyup", function () {
  //   if( this.value.length == 0) {
  //     $("#inputResults").hide();
  //   } else {
  //     $("#inputResults").show();
  //         const value = $(this).val().toLowerCase();
  //     $("#myUL li").filter(function () {
  //       $(this).text().toLowerCase().indexOf(value);
  //             //$(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
  //           });
  //         };
  // });
  

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  function checkArrow(n) {
      if (n > 0) {
        return arrowUp;
      } else {
        return arrowDown;
      }
  };
  
 function numberNegatives(y) {
      return y.replace(/([\d\.]*)-/, '');
  };
  
  function checkValue(n) {
      if (n > 0) {
        return "£"
      } else {
        return "-£"
      }
    };

  const arrowDown = `
  <svg version="1.1" class="arrowDown" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
  <path d="M4.5,8c0.3-0.3,0.8-0.3,1.1,0l7,7l7-7c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1L13,16.5
    c-0.3,0.3-0.8,0.3-1.1,0L4.5,9C4.2,8.7,4.2,8.3,4.5,8z"/>
  </svg>`;
  const arrowUp = `
  <svg version="1.1" class="arrowUp" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
  <path d="M20.7,16.5c-0.3,0.3-0.8,0.3-1.1,0l-7-7l-7,7c-0.3,0.3-0.8,0.3-1.1,0c-0.3-0.3-0.3-0.8,0-1.1L12.2,8
    c0.3-0.3,0.8-0.3,1.1,0l7.4,7.5C21,15.8,21,16.2,20.7,16.5z"/>
  </svg>`;
  
  d3.csv(mainData)
    .then(function (data) {
      const listDivOne = d3.select("#myUlOne");
      const listDivTwo = d3.select("#myUlTwo");
      const listDivThree = d3.select("#myUlThree");
      const inputDivOne = d3.select("#myInputOne");
      const inputDivTwo = d3.select("#myInputTwo");
      const inputDivThree = d3.select("#myInputThree");
      const myInputOneValue = document.getElementById("myInputOne");
      const myInputTwoValue = document.getElementById("myInputTwo");
      const myInputThreeValue = document.getElementById("myInputThree");
      const showData = d3.select(".ctaButton");

      let selectedData = { postcodeArea: "AB", propType: "Flat", numberBed: "1 bed" };
      let pushedData = [];

      const standardType = ["1 bed", "2 bed", "3 bed", "4+ bed"];
      const flatType = ["1 bed", "2 bed", "3+ bed", "Studio"];

      listDivOne.selectAll("li")
        .data(data)
        .enter()
        .append("li")
        .append("a")
        .text(function (d) { return d.postcode_area + " " + "(" + d.area_name + ")"; });
      
      listDivThree.selectAll("li")
        .data(flatType)
        .enter()
        .append("li")
        .append("a")
        .text(function (d) { return d });
    
      
      inputDivOne.on('click', function () {
        if ($("#inputResultsOne").is(":visible")) {
          $("#inputResultsOne").hide();
          $(".chavron.inputOne").css({ "transform": `rotate(0deg)` });
        } else {
          $("#inputResultsOne").show();
          $("#inputResultsTwo, #inputResultsThree").hide();
          $(".chavron.inputOne").css({ "transform": `rotate(180deg)` });
          $(".chavron.inputTwo, .chavron.inputThree").css({ "transform": `rotate(0deg)` });
        };
      });

      inputDivTwo.on('click', function () {
        if ($("#inputResultsTwo").is(":visible")) {
          $("#inputResultsTwo").hide();
          $(".chavron.inputTwo").css({ "transform": `rotate(0deg)` });
        } else {
          $("#inputResultsTwo").show();
          $("#inputResultsOne, #inputResultsThree").hide();
          $(".chavron.inputTwo").css({ "transform": `rotate(180deg)` });
          $(".chavron.inputOne, .chavron.inputThree").css({ "transform": `rotate(0deg)` });
        }; 
      });

      inputDivThree.on('click', function () {
        if ($("#inputResultsThree").is(":visible")) {
          $("#inputResultsThree").hide();
          $(".chavron.inputThree").css({ "transform": `rotate(0deg)` });
        } else {
          $("#inputResultsThree").show();
          $("#inputResultsOne, #inputResultsTwo").hide();
          $(".chavron.inputThree").css({ "transform": `rotate(180deg)` });
          $(".chavron.inputOne, .chavron.inputTwo").css({ "transform": `rotate(0deg)` });
        };
      });
            
      listDivOne.selectAll("a").on('click', function (d, i) {
        $(".chavron").css({ "transform": `rotate(0deg)` });
        $("#myInputOne p").css({ "color": `#322744`, "font-weight": `400` });

        myInputOneValue.getElementsByTagName('p')[0].innerText = i.postcode_area + " " + "(" + i.area_name + ")";
        $("#inputResultsOne, #inputResultsTwo, #inputResultsThree").hide();
       // console.log(myInputOneValue.getElementsByTagName('p')[0].innerText);

        selectedData["postcodeArea"] = i.postcode_area;

      });

      listDivTwo.selectAll("a").on('click', function (d, i) {
        $(".chavron").css({ "transform": `rotate(0deg)` });
        $("#myInputTwo p").css({ "color": `#322744`, "font-weight": `400` });

        $("#myInputTwo p").text($(this).text());
        $("#inputResultsOne, #inputResultsTwo, #inputResultsThree").hide();
        
        selectedData["propType"] = $(this).text();
        
        if ($(this).text() === "Flat") {
          //console.log("flat")
          $("#myInputThree").addClass("alert");
          $("#myInputThree p").text("1 bed");
          selectedData["numberBed"] = "1 bed";
          listDivThree.selectAll("a")
            .data(flatType)
            .text(function (d) { return d })
            .exit()
            .remove();
          setTimeout(function(){$("#myInputThree").delay(800).removeClass("alert")}, 900);
        } else {
          //console.log("standard")
          $("#myInputThree").addClass("alert");
          $("#myInputThree p").text("1 bed");
          selectedData["numberBed"] = "1 bed";
          listDivThree.selectAll("a")
            .data(standardType)
            .text(function (d) { return d })
            .exit()
            .remove();
          setTimeout(function(){$("#myInputThree").delay(800).removeClass("alert")}, 900);
        }
      });

      listDivThree.selectAll("a").on('click', function (d, i) {
        //console.log("VEIKIA")
        $(".chavron").css({ "transform": `rotate(0deg)` });
        $("#myInputThree p").css({ "color": `#322744`, "font-weight": `400` });

        $("#myInputThree p").text($(this).text());
        $("#inputResultsOne, #inputResultsTwo, #inputResultsThree").hide();

        selectedData["numberBed"] = $(this).text();
      });


      showData.on('click', function (d, i) {

        data.filter(function (d, i) {
          if (d.postcode_area === selectedData["postcodeArea"]) {
            pushedData = d;
          }
        });

        const postcodeValue = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} dec22`;
        const regionalValue = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} dec22 regional`;
        const nationalValue = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} dec22 national`;
        const postcodeValueSep = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} sep22`;
        const regionalValueSepRegional = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} sep22 regional`;
        const nationalValueSepNational = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} sep22 national`;
        const postcodeValueJun = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} jun22`;
        const regionalValueJunRegional = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} jun22 regional`;
        const nationalValueJunNational = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} jun22 national`;
        const postcodeValueMar = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} mar22`;
        const regionalValueMarRegional = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} mar22 regional`;
        const nationalValueMarNational = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} mar22 national`;
        const postcodeValueDec = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} dec21`;
        const regionalValueDecRegional = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} dec21 regional`;
        const nationalValueDecNational = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} dec21 national`;
        
        
        const yearChange = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} 12month`;
        const halfYearChange = `${selectedData["numberBed"].toLowerCase()} ${selectedData["propType"].toLowerCase()} 6month`;


        //console.log(`£${numberWithCommas(parseInt(pushedData[postcodeValue]))}`);
       // console.log(parseInt(pushedData[nationalValue]));
        //console.log(pushedData[postcodeValue]);

        function valueCheck(n) {
          if (n === "N/A") {
            return nodata;
          } else {
            return `£${numberWithCommas(parseInt(n))}`
          }
        };

        function valueCheckChange(n) {
          if (n === "N/A") {
            return nodata;
          } else {
            return `${checkValue(parseInt(n))}${numberNegatives(numberWithCommas(parseInt(n)))}${checkArrow(parseInt(n))}`
          }
        };
        


        d3.select("#dataHeadline").html(`The average value of a <span style="color:#8046F1">${selectedData["numberBed"].toLowerCase()}</span> <span style="color:#A57BF5">${selectedData["propType"].toLowerCase()}</span> is`);
        d3.select(".tabName.postcode").html(`${inputDivOne.text()}`);
        d3.select(".tabData.postcode").html(valueCheck(pushedData[postcodeValue]));
        d3.select(".tabName.regional").html(`${pushedData["region"]}`);
        d3.select(".tabData.regional").html(valueCheck(pushedData[regionalValue]));
        d3.select(".tabName.national").html(`UK`);
        d3.select(".tabData.national").html(valueCheck(pushedData[nationalValue]));
        d3.select(".tabData.year").html(valueCheckChange(pushedData[yearChange]));
        d3.select(".tabData.halfYear").html(valueCheckChange(pushedData[halfYearChange]));
        

        $("#mainDataDiv").show();

        // GRAPH STARTS

//Establishing a style object
const myThemeObject = {
  xAxisLabelFill: "#262630",
  yAxisLabelFill: "#262630",
  xAxisLabelOffset: 44,
  yAxisLabelOffset: 44,
  xAxisLabelFontSize: "12px",
  yAxisLabelFontSize: "12px",
  xAxisTickFontSize: "12px",
  yAxisTickFontSize: "12px",
  AxisTickFontFill: "#262630",
  AxisTickLineStroke: "#F1F1F7",
  AxisDomainLineStroke: "#F1F1F7",
  xAxisTickDensity: 60, //Pixel per tick
  yAxisTickDensity: 40, //Pixel per tick
};
        
   function dataCheck(n) {
          if (n === "N/A") {
            return 500000
          } else {
            return parseInt(n)
          }
        };   
        
        function dataCheckAll(n) {
          if (n === "N/A") {
            return nodata
          } else {
            return parseInt(n)
          }
        };   
        
        function dataCheckAllGraph(n) {
          if (Number.isInteger(n)) {
            return `£${numberWithCommas(n)}`
          } else {
            return nodata
          }
     };   
     
  
    function dataCheckGraph(n) {
          if (n === 500000) {
            return nodata;
          } else {
            return `£${numberWithCommas(n)}`
          }
    };
        
const dataGraph = [{
  name: "Dec-21",
  value: dataCheck(pushedData[postcodeValueDec]),
  regional: dataCheckAll(pushedData[regionalValueDecRegional]),
  uk: dataCheckAll(pushedData[nationalValueDecNational])
}, {
  name: "Mar-22",
  value: dataCheck(pushedData[postcodeValueMar]),
  regional: dataCheckAll(pushedData[regionalValueMarRegional]),
  uk: dataCheckAll(pushedData[nationalValueMarNational])
}, {
  name: "Jun-22",
  value: dataCheck(pushedData[postcodeValueJun]),
  regional: dataCheckAll(pushedData[regionalValueJunRegional]),
  uk: dataCheckAll(pushedData[nationalValueJunNational])
}, {
  name: "Sep-22",
  value: dataCheck(pushedData[postcodeValueSep]),
  regional: dataCheckAll(pushedData[regionalValueSepRegional]),
  uk: dataCheckAll(pushedData[nationalValueSepNational])
  }, {
  name: "Dec-22",
  value: dataCheck(pushedData[postcodeValue]),
  regional: dataCheckAll(pushedData[regionalValue]),
  uk: dataCheckAll(pushedData[nationalValue])
}
];
       
        
    
        //console.log(dataGraph)
        
//  if (document.getElementById("wrapper").clientWidth > 540) {
//        return 320
//      } else {
//        return 300
//      }
//Render the visualisation at first//
render();
//Render the visualisation on window resize//
window.addEventListener("resize", render);

//The function of Render//
        function render() {
     
     function screenCheck(n) {
       if (n > 540) {
       return 320
     } else {
       return 300
     }
     };
     
  const chart = d3.select("#graph");

  myResponsiveComponent(
    chart,
    Object.assign({}, myThemeObject, {
      width: document.getElementById("wrapper").clientWidth,
      height: screenCheck(document.getElementById("wrapper").clientWidth),
      margin: { top: 32, bottom: 32, left: 8, right: 48 },
    })
  );
}

//The margin function with svg g element inside which is fired in main deatiled function below//
function marginComponents(selection, props) {
  const { width, height, margin } = props;
  let g = selection.selectAll(".marginGroup").data([null]);
  g = g
    .enter()
    .append("g")
    .attr("class", "marginGroup")
    .merge(g)
    .attr("transform", `translate(${margin.left}, ${margin.top})`);

  const innerWidth = width - margin.left - margin.right;
  const innerHeight = height - margin.top - margin.bottom;

  return { g, innerWidth, innerHeight };
}

//The entire detailed function of what happens while render is triggered//
function myResponsiveComponent(selection, props) {
  const { width, height, margin } = props;

  let svg = selection.selectAll("svg").data([null]);
  svg = svg
    .enter()
    .append("svg")
    .merge(svg)
    .attr("width", width)
    .attr("height", height);

  //Run margin function with objects aside
  const { g, text, innerWidth, innerHeight } = marginComponents(svg, {
    width,
    height,
    margin,
  });
  
    const yScale = d3
      .scaleLinear()
      .domain([d3.min(dataGraph, function(d){return d.value}) - 10000, d3.max(dataGraph, function(d){return d.value}) + 10000])
      .range([innerHeight, 0])
      .nice();

     const xScale = d3
      .scalePoint()
      .domain(dataGraph.map(function(d) {
        return d.name
      }))
      .range([0, innerWidth])
      .padding(0.25);
  
  const line = d3.line().curve(d3.curveNatural)
	  .x(function(d){ return xScale(d.name)})
    .y(function (d) { return yScale(d.value) });


  labeledYAxis(g, Object.assign({}, props, { yScale, innerHeight })); //see function below for labels Y
  labeledXAxis(
    g,
    Object.assign({}, props, { data, xScale, innerHeight, innerWidth })
  ); //see function below for labels X
    
  
  let valueLine = g.selectAll(".valueLineS").data([null]);
    valueLine = valueLine
      .enter()
      .append("path")
      .attr("class", "valueLineS")
      .merge(valueLine)
      .attr("d", line(dataGraph));
  
  
  
        d3.select(".tabData.postcode").html(valueCheck(pushedData[postcodeValue]));
        d3.select(".tabData.regional").html(valueCheck(pushedData[regionalValue]));
        d3.select(".tabData.national").html(valueCheck(pushedData[nationalValue]));
  
        // if (postcode === "£NaN") {
        //   d3.select(".tabData.postcode").text("no data");
        // };
    
  
  //hover functions

  let linesStatic = g.selectAll(".lineStyleStatic").data(dataGraph); //for any data led object needs to be data instead [null]
  linesStatic
    .data(dataGraph)
    .enter()
    .append("line") //data needs t omatch the above line [data]
    .attr("class", "lineStyleStatic")
    .merge(linesStatic)
    .attr("x1", function (d) {
        return xScale(d.name);
      })
    .attr("y1", 0)
    .attr("x2", function (d) {
        return xScale(d.name);
      })
    .attr("y2", innerHeight)
    .attr("opacity", function (d, i) { 
        if (d.name === "Dec-22") {
          return 1
        } else {
          return 0
        }
    });
 
   
  const circle = g.selectAll(".circleStyle").data(dataGraph); //for any data led object needs to be data instead [null]
  circle
    .data(dataGraph)
    .enter()
    .append("circle") //data needs t omatch the above line [data]
    .attr("class", "circleStyle")
    .merge(circle)
    .attr("r", function (d, i) {
      if (d.name === "Dec-22") {
        return "12px"
      } else {
        return "6px"
      }
    })
    .attr("cy", function (d) {
      return yScale(d.value);
    })
    .attr("cx", function (d) {
      return xScale(d.name);
    })
    .attr("fill", function (d, i) {
      if (d.name === "Dec-22") {
        return "#BE9FF8"
      } else {
        return "#BE9FF8"
      }
    });
    // g.selectAll("tick").on("mouseover", function () {linesStatic.attr("opacity", 0)});
      //.on("mousemove", mousemoveHighlight)
      //.on("mouseout", mouseout);

  
  
  // Create the circle that travels along the curve of chart

   let lines = g.selectAll(".lineStyle").data([null]); //for any data led object needs to be data instead [null]
  lines = lines
    .enter()
    .append("line") //data needs t omatch the above line [data]
    .attr("class", "lineStyle")
    .merge(lines)
    .style("opacity", 0);
   
  
  let focus = g.selectAll('.circleStyleFocus').data([null]);
  focus = focus
    .enter()
    .append("circle")
    .attr("class", "circleStyleFocus")
    .merge(focus)
    .style("opacity", 0);
    
  
  let focusRect = g.selectAll('.rectFocusStyle').data([null]);
  focusRect = focusRect
    .enter()
    .append("rect")
    .attr("class", "rectFocusStyle")
    .merge(focusRect)
    .attr("opacity", 0)
    .attr("x", 0)
    .attr("width", innerWidth)
    .attr("height", innerHeight)
    .on('mouseover', mouseover)
    .on('mousemove', mousemove)
    //.on('mouseout', mouseout);
  
  
   //What happens when the mouse move -> show the annotations at the right positions.
  function mouseover() {
    focus.style("opacity", 1)
    lines.style("opacity", 1);
    //focusText.style("opacity",1)
    g.selectAll(".lineStyleStatic").attr("opacity", 0);
  };

  function mousemove(e) {

    const xPos = d3.pointer(e)[0];
    //var domain = xScale.domain();
    const range = xScale.range();
    const rangePoints = d3.range(range[0], range[1], xScale.step())
    const yPos = d3.bisect(rangePoints, xPos) - 1;
    
    let selectedData = dataGraph[yPos]

    focus
      .attr("cx", xScale(selectedData.name) )
      .attr("cy", yScale(selectedData.value))
      .style("r", "12px")
      .style("fill", "#8046F1");
    
    lines
      .attr("x1", xScale(selectedData.name) )
    .attr("y1", 0)
    .attr("x2", xScale(selectedData.name) )
    .attr("y2", innerHeight)
   // .attr("opacity", 1);
    
    d3.select(".tabData.postcode").html(dataCheckGraph(dataGraph[yPos].value));
    d3.select(".tabData.regional").html(dataCheckAllGraph(dataGraph[yPos].regional));
    d3.select(".tabData.national").html(dataCheckAllGraph(dataGraph[yPos].uk));
    
//console.log(dataGraph[yPos].value)
    
  };

  function mouseout() {
    focus.style("opacity", 0)
    //focusText.style("opacity", 0)
  };
  

  
  
  };


        //GRAPH ENDS
           
  });


      $("#changeData").click(function () {
        $("#mainDataDiv").hide();
        d3.selectAll("svg > *").remove();
      });

      $(".methodologyBtn").click(function () {
        $(".parentMethodDiv").fadeIn(200);
      });

       $(".closeIcon").click(function () {
        $(".parentMethodDiv").fadeOut(200);
      });
    
      
  })
  .catch(function (error) {
      console.log("Error - Please reload the page");
  });
  


}());

